export const LAYERS = [
  { key: "q", letter: "Q", name: "Wahyu", sub: "Quran" },
  { key: "v", letter: "V", name: "Nilai", sub: "Values" },
  { key: "k", letter: "K", name: "Ilmu", sub: "Knowledge" },
  { key: "i", letter: "I", name: "Inovasi", sub: "Innovation" },
];

export const CHIPS_LANGIT = ["13:11", "Al-'Asr 1-3", "94:5-6", "Al-Hasyr 18", "2:286"];
export const CHIPS_BUMI = ["Anak muda hilang motivasi belajar", "Pasukan kerja tidak sepakat", "Hutang isi rumah meningkat", "Ahli rumah ngaji tidak konsisten hadir"];
export const KONTEKS = ["Umum", "Diri dan keluarga", "Organisasi dan korporat", "Pendidikan dan latihan", "Masyarakat dan dakwah", "Ekonomi dan kewangan", "Kepimpinan dan pasukan"];
export const ARAHAN_CHIPS = ["Fokus pada kisah para nabi", "Ayat tentang syura dan kerja berpasukan", "Ayat doa", "Ayat yang lebih praktikal untuk tindakan"];

export function hteToText(d) {
  const L = [];
  L.push(`HTE · ${d.rujukan}`);
  if (d.isu) L.push(`Isu: ${d.isu}`);
  if (d.kenapa_ayat_ini) L.push(`Kenapa ayat ini: ${d.kenapa_ayat_ini}`);
  L.push(`Konteks: ${d.konteks}`, "", d.arab, "", `Terjemahan: ${d.terjemahan}`, "");
  L.push("Q · WAHYU", `Mesej teras: ${d.q.mesej_teras}`, "Pandangan mufassir:");
  d.q.pandangan_mufassir.forEach((p) => L.push(`- ${p.nama_ar}: ${p.ringkasan}`));
  if (d.q.ayat_berkaitan.length) {
    L.push("Ayat berkaitan:");
    d.q.ayat_berkaitan.forEach((a) => L.push(`- ${a.rujukan}${a.kaitan ? ` — ${a.kaitan}` : ""}`));
  }
  const box = (title, obj, keys) => {
    L.push("", title);
    keys.forEach(([k, label]) => { L.push(`${label}:`); (obj[k] || []).forEach((x) => L.push(`- ${x}`)); });
  };
  box("V · NILAI", d.v, [["nilai", "Nilai"], ["prinsip", "Prinsip"], ["budaya", "Budaya"]]);
  box("K · ILMU", d.k, [["ilmu", "Ilmu"], ["kemahiran", "Kemahiran"], ["sistem", "Sistem"]]);
  L.push("", "I · INOVASI");
  d.i.forEach((x, n) => L.push(`${n + 1}. ${x.nama} — ${x.huraian}`));
  L.push("", `AMANAH 7 HARI: ${d.amanah}`, "", "Dijana dengan ATAS · HTE. Terjemahan: Abdullah Muhammad Basmeih.");
  return L.join("\n");
}
